import React, { useState, useLayoutEffect } from "react";
import styled from "styled-components";
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";
import logo from "../../assets/logo1.png";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import "./sidebar.css";

const SidebarNav = styled.nav`
  background: linear-gradient(
    180deg,
    var(--sb-bg-top, #0c2268) 0%,
    var(--sb-bg-bottom, #061540) 100%
  );
  font-size: 10px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${({ isMobile, sidebar }) => (isMobile && !sidebar ? "-100%" : "0")};
  width: ${({ isMobile, sidebar }) => {
    if (isMobile) return "var(--sb-expanded-w, 212px)";
    return sidebar
      ? "var(--sb-expanded-w, 212px)"
      : "var(--sb-collapsed-w, 52px)";
  }};
  transition:
    left 280ms cubic-bezier(0.4, 0, 0.2, 1),
    width 280ms cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 20;
  overflow: visible;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.18);
`;

const SidebarWrap = styled.div`
  width: 100%;
  font-size: 10px;
  height: 100vh;
  font-family: "Segoe UI", Roboto, sans-serif;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: visible;
`;

const Sidebar = () => {
  const [sidebar, setSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false,
  );
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const applyContentWidth = (mode) => {
    const contentEl = document.getElementById("content-width");
    if (!contentEl) return;

    contentEl.classList.remove(
      "content-width",
      "content-width-full",
      "content-width-collapsed",
    );

    if (mode === "full") {
      contentEl.classList.add("content-width-full");
    } else if (mode === "collapsed") {
      contentEl.classList.add("content-width-collapsed");
    } else {
      contentEl.classList.add("content-width");
    }
  };

  const handleMenuToggle = (index) => {
    if (!sidebar && !isMobile) {
      return;
    }

    setOpenMenuIndex((prev) => (prev === index ? null : index));
  };

  const closeAllMenus = () => setOpenMenuIndex(null);

  const expandSidebar = () => {
    applyContentWidth("expanded");
    setSidebar(true);
  };

  const collapseSidebar = () => {
    closeAllMenus();
    applyContentWidth(isMobile ? "full" : "collapsed");
    setSidebar(false);
  };

  const toggleSidebar = () => {
    if (sidebar) {
      collapseSidebar();
    } else {
      expandSidebar();
    }
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      if (mobile) {
        setSidebar(false);
        closeAllMenus();
        applyContentWidth("full");
      } else {
        setSidebar(false);
        applyContentWidth("collapsed");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isCollapsed = !sidebar && !isMobile;

  return (
    localStorage.getItem("token") &&
    !window.location.toString().includes("preview/invoice") && (
      <>
        {isMobile && !sidebar && (
          <button
            className="sidebar-mobile-open-tab"
            onClick={toggleSidebar}
            aria-label="Open sidebar"
          >
            <IoChevronForward />
          </button>
        )}
        <div
          id="sidebar-width"
          className={`sidebar-width ${
            sidebar ? "show" : isMobile ? "hide" : "collapsed"
          }`}
        >
          <IconContext.Provider value={{ color: "rgba(255,255,255,0.95)", size: "16px" }}>
            <SidebarNav
              sidebar={sidebar}
              isMobile={isMobile}
              className="side-width-auto"
            >
              <button
                className="sidebar-collapse-toggle"
                onClick={toggleSidebar}
                aria-label={sidebar ? "Collapse sidebar" : "Expand sidebar"}
              >
                {sidebar || isMobile ? (
                  <IoChevronBack />
                ) : (
                  <IoChevronForward />
                )}
              </button>

              <SidebarWrap
                className={isCollapsed ? "sidebar-collapsed-mode" : ""}
              >
                {isCollapsed && <div className="sidebar-collapsed-spacer" />}

                {!isCollapsed && (
                  <div id="logo" className="sidebar-brand-text">
                    <img
                      src={logo}
                      alt="Aptitude Migration"
                      className="sidebar-logo"
                    />
                  </div>
                )}

                <div
                  className={
                    isCollapsed ? "sidebar-menu-list" : "sidebar-menu-list-expanded"
                  }
                >
                  {SidebarData.map((item, index) => {
                    return (
                      <SubMenu
                        item={item}
                        key={index}
                        isOpen={openMenuIndex === index}
                        onToggle={() => handleMenuToggle(index)}
                        onCloseAll={closeAllMenus}
                        sidebarClose={isCollapsed}
                      />
                    );
                  })}
                </div>
              </SidebarWrap>
            </SidebarNav>
          </IconContext.Provider>
        </div>
      </>
    )
  );
};

export default Sidebar;
